import { render, staticRenderFns } from "./AddToken.vue?vue&type=template&id=477225f1&"
import script from "./AddToken.vue?vue&type=script&lang=js&"
export * from "./AddToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports